import dayjs from 'dayjs';

export const domTitle = 'LaClub积分商城';

export const setDocumentTitle = (title) => {
  document.title = title;
};

export const formatDate = (seconds) => dayjs(seconds).format('YYYY-MM-DD');

export const formatDateTime = (seconds) => dayjs(seconds).format('YYYY-MM-DD HH:mm');

export const formatDateDiff = (frontDate, afterDate, format = 'day') => {
  const front = dayjs(frontDate);
  const after = dayjs(afterDate);
  return front.diff(after, format);
};

export const orderStatusObj = {
  1: '待收货',
  2: '待自提',
  3: '已完成',
  4: '待发货',
};
